import Vue from 'vue';
import VueRouter from 'vue-router';
import { ratingList } from '@/api/base';
//index
const main = () => import('@/views/main/main');
const mainPost = () => import('@/views/createPost/index');
// 404

const index = () => import(/* webpackChunkName: "404" */ '@/views/index/index');
const NotFound = () => import(/* webpackChunkName: "404" */ '@/views/404/index');

Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    meta: { title: '一尘盯盘' },
    component: main,
    children: [
      {
        path: '',
        component: () => import('@/views/plate/index'),
        meta: { title: '', keepAlive: true },
      },
    ],
  },
  {
    path: '/login',
    meta: { title: '登录中' },
    component: () => import('@/views/auth/index'),
  },
  {
    path: '/index',
    meta: { title: '' },
    component: main,
    children: [{ path: '', component: index, meta: { title: '一尘盯盘' } }],
  },
  {
    path: '/plate',
    meta: { title: '' },
    component: main,
    children: [
      {
        path: '',
        name: 'index',
        component: () => import('@/views/plate/index'),
        meta: { title: '看一尘网', keepAlive: true },
      },
      {
        path: 'list',
        name: 'plateList',
        component: () => import('@/views/plate/list'),
        meta: { title: '版块信息', keepAlive: true },
      },
    ],
  },
  {
    path: '/user',
    meta: { title: '' },
    component: main,
    children: [
      { path: '', component: () => import('@/views/user/index'), meta: { title: '个人中心' } },
    ],
  },
  {
    path: '/subscribe',
    component: () => import('@/views/personal/index'),
    meta: { title: '我的盯盘' },
  },
  {
    path: '/posts',
    component: main,
    children: [
      { path: '', name: 'posts', component: () => import('@/views/plate/posts'), meta: {} },
    ],
  },
  {
    path: '/follow',
    component: () => import('@/views/personal/followList'),
    meta: { title: '我的关注帖' },
  },
  {
    path: '/vip',
    component: () => import('@/views/vip/index'),
    meta: { title: '开通会员' },
  },
  {
    path: '/ycRegistry',
    component: () => import('@/views/registry/index'),
    meta: { title: '一尘注册' },
  },
  {
    path: '/hot',
    component: () => import('@/views/hot/index'),
    meta: { title: '热搜' },
  },
  {
    path: '/blacklist',
    component: () => import('@/views/blacklist/index'),
    meta: { title: '黑名单' },
  },
  {
    path: '/ranking',
    component: main,
    children: [
      {
        path: '',
        name: 'posts',
        component: () => import('@/views/hotRanking/index'),
        meta: { title: '盘口数据' },
      },
    ],
  },
  {
    path: '/activity',
    component: () => import('@/views/activity/index'),
    meta: { title: '分享赚现金' },
  },
  {
    path: '/share',
    component: () => import('@/views/activity/share'),
    meta: { title: '一尘盯盘助手代理通道' },
  },
  {
    path: '/yclogin',
    component: () => import('@/views/login/index'),
    meta: { title: '一尘账号授权登录' },
  },

  {
    path: '/createPost',
    component: main,
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/createPost/post'),
        meta: { title: '发帖' },
      },
    ],
  },
  {
    path: '/createPost',
    component: main,
    children: [
      {
        path: 'list',
        name: '',
        component: () => import('@/views/createPost/list'),
        meta: { title: '手机发帖' },
      },
    ],
  },
  {
    path: '/reply',
    component: mainPost,
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/createPost/reply'),
        meta: { title: '回复' },
      },
    ],
  },
  {
    path: '/postList',
    component: () => import('@/views/createPost/postList'),
    meta: { title: '发帖列表' },
  },
  {
    path: '/promotion',
    component: () => import('@/views/ad/index'),
    meta: { title: '诚邀合作' },
  },
  {
    path: '/adView',
    component: () => import('@/views/ad/view'),
    meta: { title: '详情' },
  },
  {
    path: '/postView',
    component: mainPost,
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/createPost/postView'),
        meta: { title: '详情', keepAlive: true },
      },
    ],
  },
  {
    path: '/partake',
    component: mainPost,
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/createPost/postView'),
        meta: { title: '我参与的帖子', keepAlive: true },
      },
    ],
  },
  {
    path: '/score',
    component: mainPost,
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/createPost/score'),
        meta: { title: '帖子评分' },
      },
    ],
  },
  {
    path: '/participates',
    component: () => import('@/views/createPost/participates'),
    meta: { title: '我参与的帖子' },
  },
  {
    path: '/ratingList',
    component: () => import('@/views/createPost/ratingList'),
    meta: { title: '评分列表' },
  },
  {
    path: '/coin',
    component: () => import('@/views/coin/index'),
    meta: { title: '纪念币实时走势' },
  },
  // {
  //   path: '/rtjQuote',
  //   component: () => import('@/views/rtjQuote/index'),
  //   meta: { title: '贵金属行情' },
  // },
];

const router = new VueRouter({
  routes,
});

export default router;
